import * as React from 'react';

import { QuizItemCache } from 'clients/app/src/api/quiz/getQuizzes/normalize/toQuizItemCache';

import { translate } from '~l10n/client';
import { Breadcrumbs } from '~shared/components/Breadcrumbs';

export interface PersonalQuizzesBreadcrumbsProps {
  currentItem: {
    parentId: number;
    uniqueId?: string;
    name: string;
    type: 'folder' | 'quiz';
  };
  folders: QuizItemCache['itemById'];
  hideCurrent?: boolean;
}

export function PersonalQuizzesBreadcrumbs({
  currentItem,
  folders,
  hideCurrent = false,
}: PersonalQuizzesBreadcrumbsProps) {
  const crumbs = getPersonalBreadCrumbs({ currentItem, folders });

  return <Breadcrumbs hideCurrent={hideCurrent} crumbs={crumbs} />;
}

interface GetPersonalBreadCrumbsParams {
  currentItem: {
    parentId: number;
    uniqueId?: string;
    name: string;
    type: 'folder' | 'quiz';
  };
  folders: QuizItemCache['itemById'];
  crumbs?: Array<{ label: string; href: string }>;
}

export function getPersonalBreadCrumbs({
  currentItem,
  folders,
  crumbs = [],
}: GetPersonalBreadCrumbsParams) {
  // no path
  if (currentItem == null || folders == null) {
    return [{ label: translate('Personal'), href: '#quizzes' }, ...crumbs];
  }

  const breadcrumbs = [...crumbs];
  let current = currentItem;
  let iterationCount = 0;
  const maxIterations = 100; // Sanity check to prevent infinite loops

  // Build breadcrumbs by traversing up the folder hierarchy
  while (current != null && iterationCount < maxIterations) {
    // Validate current item has required properties
    if (!current.name || !current.uniqueId || !current.type) {
      console.warn('Invalid item in breadcrumb hierarchy:', current);
      break;
    }

    breadcrumbs.unshift({
      label: current.name,
      href:
        current.type === 'folder'
          ? `#quizzes/${current.uniqueId}`
          : `#edit-quiz/${current.uniqueId}`,
    });

    // Move to parent folder
    current = current.parentId ? folders[`folder-${current.parentId}`] : null;
    iterationCount++;
  }

  // Warn if we hit the iteration limit
  if (iterationCount >= maxIterations) {
    console.warn(
      'Breadcrumb iteration limit reached, possible circular reference'
    );
  }

  // Add the root "Personal" breadcrumb at the beginning
  breadcrumbs.unshift({ label: translate('Personal'), href: '#quizzes' });

  return breadcrumbs;
}
